import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import { Link } from "react-router-dom";

import PagingView from "../../component/PagingView";
import { GetList } from "../../lib/Board";
import { Get } from "../../lib/Config";
import moment from "moment";

import ScrollOut from "scroll-out";

const Person = () => {
    const [years, setYears] = useState([]);
    const [recruitFile, setRecruitFile] = useState();
    const [items, setItems] = useState([]);
    const [data, setData] = useState({
        page: 1,
        size: 30,
        sort: "-id",
        board: "recruit",
        title: "",
        year: ""
    });

    const [range, setRange] = useState({
        end: 0,
        size: 1,
        start: 0,
        total: 1
    });

    useEffect(() => {
        for (var i = moment().format("YYYY"); i >= 2021; i--) {
            years.push(i);
        }
        setYears(years);

        reloadList(1);
        Get("RECRUITFILE", res => {
            console.log("recruitFile", res);
            setRecruitFile(res);
        });

        ScrollOut({
            threshold: 0,
            once: true
        });
    }, []);

    const reloadList = page => {
        data.page = page;
        setData(data);
        GetList(data, resultList);
    };

    /**
     * 리스트
     */
    const resultList = response => {
        setItems(response.rows);
        setRange(response.range);
    };

    return (
        <>
            <SubHead title="채용안내" eng="GUIDE"></SubHead>
            <main className="sub-contents">
                <div className="inner" data-scroll>
                    <p className="tit-guide-sbj">
                        ㈜kt MOS 북부와 함께 최고의 기업으로 이끌어갈 <b>열정과 패기를 가진 인재</b>를 모십니다.
                    </p>

                    <p className="red-sub-tit">모집분야</p>
                    <table className="tbl_normal wAuto">
                        <colgroup>
                            <col width="20%" />
                            <col width="auto" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>모집분야</th>
                                <td className="textL">KT기지국/중계기 운용관리, 네트워크망 관리, 통화품질 고객접점관리</td>
                            </tr>
                            <tr>
                                <th>채용시기</th>
                                <td className="textL">부서별 채용계획에 따라 수시 채용</td>
                            </tr>
                        </tbody>
                    </table>
                    {recruitFile && (
                        <div className="table-bottom-btns sm">
                            <a href={recruitFile.value}>
                                <button type="button" className="btn_nor red-line wide lg">
                                    입사지원서 양식 다운받기
                                </button>
                            </a>
                        </div>
                    )}

                    <p className="red-sub-tit">채용절차</p>

                    <div className="guide-step-wrap">
                        <ul>
                            <li>
                                <div className="icon n01"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 01</p>
                                    <p>입사지원</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon n02"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 02</p>
                                    <p>서류전형</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon n03"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 03</p>
                                    <p>면접전형</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon n044"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 04</p>
                                    <p>인적성검사</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon n04"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 05</p>
                                    <p>최종합격</p>
                                </div>
                            </li>
                            <li>
                                <div className="icon n05"></div>
                                <div className="texts">
                                    <p className="sbj">STEP. 06</p>
                                    <p>신입교육</p>
                                </div>
                            </li>
                        </ul>
                    </div>

                    <div className="seperate-line"></div>

                    <p className="red-sub-tit">채용공고</p>

                    <form className="search-form">
                        <label>검색</label>
                        <select
                            value={data.year}
                            onChange={e => {
                                data.year = e.target.value;
                                setData({ ...data });
                            }}
                        >
                            <option key={""}>년도별</option>
                            {years.map(x => (
                                <option key={x}>{x}</option>
                            ))}
                        </select>
                        <input
                            type="text"
                            placeholder="검색어를 입력하세요"
                            value={data.title}
                            onChange={e => {
                                data.title = e.target.value;
                                setData({ ...data });
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => {
                                reloadList(1);
                            }}
                        >
                            검색
                        </button>
                    </form>

                    <div className="board-list-top">
                        <p className="total">
                            Total {range.total}건 {Math.ceil(Number(range.total) / Number(range.size))}페이지
                        </p>
                    </div>

                    <div className="board-list-wrap">
                        <table className="board-list">
                            <colgroup>
                                <col width="10%" />
                                <col width="auto" />
                                {/* <col width="10%" />
                                <col width="10%" />
                                <col width="10%" /> */}
                                <col width="10%" />
                                <col width="10%" />
                            </colgroup>
                            <thead>
                                <th>NO</th>
                                <th>내용</th>
                                {/* <th>파일</th>
                                <th>작성자</th>
                                <th>조회수</th> */}
                                <th>작성일</th>
                                <th>마감일</th>
                            </thead>
                            <tbody>
                                {items.map(x => (
                                    <tr>
                                        <td>{x.id}</td>
                                        <td className="textL">
                                            <Link to={`/recruit/info/${x.id}`}>
                                                <span className="sbj">{x.title}</span>
                                                {/* <span className="icons-lock"></span> */}
                                            </Link>
                                        </td>
                                        {/* <td>{x.files.length > 0 && <span className="icons-file"></span>}</td>
                                        <td>{x.name}</td>
                                        <td>{x.show}</td> */}
                                        <td className="writeDay">{moment(x.createdAt).format("YYYY.MM.DD")}</td>
                                        <td className="endDay">2022.10.21</td>
                                    </tr>
                                ))}
                                {/* <tr>
                                    <td>25</td>
                                    <td className="textL">
                                        <a href="#" className="link">
                                            <span className="sbj">NIA 이음 5G 융합서비스 공공부문 Access망 구축공사 감리 입찰공고</span>
                                            <span className="icons-lock"></span>
                                        </a>
                                    </td>
                                    <td>
                                        <span className="icons-file"></span>
                                    </td>
                                    <td>최고관리자</td>
                                    <td>19</td>
                                    <td className="writeDay">2022.09.21</td>
                                    <td className="endDay">2022.10.21</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>

                    <PagingView nowPage={Number(data.page)} totalPage={Math.ceil(Number(range.total) / Number(range.size))} reload={reloadList} />
                </div>
            </main>
        </>
    );
};

export default Person;
